import { useQuery } from "@tanstack/react-query";
import { fetchers } from "../fetchers";

export const NOTES_KEY = "notes";

const PUBLIC_NOTE_KEY = "public_note";
const useNoteByPublicUuid = (publicUuid?: string) => {
  return useQuery({
    queryKey: [PUBLIC_NOTE_KEY, publicUuid],
    queryFn: () => (publicUuid ? fetchers.notes.getNoteByPublicUuid(publicUuid) : undefined),
  });
};

const useNoteById = (noteId?: number) => {
  return useQuery({
    queryKey: [NOTES_KEY, noteId],
    queryFn: () => (noteId ? fetchers.notes.fetchNoteById(noteId) : undefined),
    enabled: !!noteId,
  });
};

export const notesHooks = {
  useNoteById,
  useNoteByPublicUuid,
};
